import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { SAVE_RESULT_STATUS } from '../../constants/app-data.constants';

@Component({
  selector: 'app-vmg-email-template',
  templateUrl: './vmg-email-template.component.html',
  styleUrl: './vmg-email-template.component.scss'
})
export class VmgEmailTemplateComponent extends BaseCardSetDetailComponent implements OnInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.vmgEmailTemplate;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  applicationId = '';
  showTemplateUpdateSection = false;
  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private dataService: DataService,
    private spinnerService: SpinnerService,
    private errorService: ErrorService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      this.applicationId = paramMap.get('applicationId');
      if (this.applicationId) {
        this.id = this.applicationId;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getVmgEmailTemplateConfigAndResponse;
        this.coreService.fileUploadFormIdentifiers['applicationDocumentPlaceholder'] = this.id;
      }
    });
    this.coreService.applicationFunctions = {
      displayBtnSave: () => true,
      displayBtnSend: () => true,
      send: () => this.send()
    },
      this.coreService.conditionFunctions = {
        true: () => true,
        showTemplateUpdateSection: () => this.showTemplateUpdateSection,
      }
  }

  formLoaded(event: any): void {
    this.showTemplateUpdateSection = event.showTemplateUpdateSection;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
    this.notAvailableFeature();
  }

  save(event: SaveFormEvent) {
    const request = this.createRequest(event.model);
    this.saveData(
      request,
      API_ENDPOINTS.applicationDetailCreateUpdateCarer.saveVmgEmailTemplate
    ).subscribe((data) => {
      this.spinnerService.hideSpinner();
      if (data?.status === SAVE_RESULT_STATUS.success)
        this.reloadPage();
    });
  }

  cancel(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdateCarer.prefix, this.id]);
  }

  private createRequest(response: any = '') {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response,
      expectedLastUpdateTime: this.baseForm.lastUpdatedTime ?? null,
      isSubmit: false,
    };
    return saveDataRequest;
  }

  private saveData(request: SaveDataRequest, endPoint: string) {
    this.spinnerService.showSpinner();
    return this.dataService
      .saveData(endPoint, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      );
  }

  send() {
    this.notAvailableFeature();
  }
}
